import { render, staticRenderFns } from "./PaytL_List.vue?vue&type=template&id=328a2968"
import script from "./PaytL_List.vue?vue&type=script&lang=js"
export * from "./PaytL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports